<!-- eslint-disable  -->
<template lang="pug">
    #app.h-100.d-flex.flex-column.justify-content-between
        AppVersionModal
        div.page-content.pt-lg-4.flex-grow-1
            .spacer(:class="$store.getters.videoBannerActive && !isMobile ? 'active' : ''")
            router-view.app-padding.h-100
        FooterAgent(v-if="isLogged")
</template>
<!-- eslint-enable  -->

<style>
    .page-content {
        max-height: fit-content;
        /* min-height: 80%; */
    }
    .spacer {
        transition: all 1s;
        height: 0;
    }
    .spacer.active {
        height: 45px;
    }

    .no-logged #WACContainer {
        display: none !important;
    }

    /**
    Watson IA Styles
    */
    .WACMainWindow,
    .WACHeader__Name,
    .WACHomeScreen__greeting,
    .WACWidget__MarkdownP {
        font-family: "Roboto Slab", serif !important;
    }

    .WACHomeScreen__avatarHolder {
        display: none !important;
    }

    .WACMessage__Label {
        display: none !important;
    }

    #iframe {
        position: absolute;
        float: left;
        clear: both;
        width: 100%;
        height: 100%;
        z-index: 0;
    }

    #refreshButton {
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 0;
        border: none;
        background: none;
        cursor: pointer;
        z-index: 1000;
    }
    #refreshButton img {
        width: 24px;
        height: 24px;
    }

    .info-image {
        width: 15px !important;
        height: 15px !important;
        vertical-align: middle !important;
    }

    .info-container {
        align-items: center !important;
        float: right !important;
    }

    #chat-container {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50%;
        z-index: 1;
    }
    #WACContainer.WACContainer .WACWidget__textEllipsis {
        overflow: visible !important;
    }
    .WACHeader__CenterContainer {
        justify-content: space-between !important;
    }
    .cds--list__item{
        font-family:"Roboto Slab", serif !important;
    }
    @media (max-width: 768px) {
        .WACLauncher__ButtonContainer {
            bottom: 90px !important;
        }
    }
</style>

<script>
    import { Capacitor } from '@capacitor/core';
    /* global docx */

    window.initWatson = function () {
        const messages = [];
        // obtener el token directamente de localStorage
        const token = localStorage.getItem('PACOAT');
        let chatInstance;
        let inactivityTimer;
        const inactivityInterval = 480000;
        let mensajeEnviado = false;
        let conversacion_id = null;
        let primero = 0;
        let jwt;

        if (token) {
            try {
                jwt = atob(token);
            } catch (error) {
                console.error('Error al decodificar el token:', error);
                jwt = 'user-fallback'; // valor por defecto si el token es inválido
            }
        } else {
            console.warn('No hay token PACOAT en localStorage, usando valor por defecto');
            jwt = ''; // valor por defecto si el token es inválido
        }

        function waitForElm(selector) {
            return new Promise(resolve => {
                if (document.querySelector(selector)) {
                    return resolve(document.querySelector(selector));
                }

                const observer = new MutationObserver(() => {
                    if (document.querySelector(selector)) {
                        observer.disconnect();
                        resolve(document.querySelector(selector));
                    }
                });

                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            });
        }

        function limpiarYAgregarContenido() {
            waitForElm('.WACHomeScreen__initialContent').then(elm => {
                elm.innerHTML = '';

                const titulo = document.createElement('h1');
                titulo.textContent = 'AVISO LEGAL';
                titulo.style.fontSize = '24px';
                titulo.style.fontWeight = 'bold';
                titulo.style.color = '#333';
                titulo.style.marginBottom = '10px';
                elm.appendChild(titulo);

                const texto = document.createElement('p');
                texto.textContent =
                    'La información facilitada por el asistente virtual de Cobas Asset Management, S.G.I.I.C., S.A., Cobas IA, en ningún caso podrá entenderse como recomendación, previsión o asesoramiento financiero. En caso de discrepancia, la información recogida en la documentación legal y en la página web de Cobas Asset Management, S.G.I.I.C., S.A. prevalecerá frente a la información facilitada por el asistente virtual. Para cualquier aclaración contacte con el equipo de Relación con Inversores de Cobas Asset Management, S.G.I.I.C., S.A.';
                texto.style.fontSize = '16px';
                texto.style.color = '#666';
                texto.style.lineHeight = '1.5';
                texto.style.marginBottom = '20px';
                elm.appendChild(texto);

                const botonAceptar = document.createElement('button');
                botonAceptar.textContent = 'Aceptar';
                botonAceptar.style.backgroundColor = '#498b2a';
                botonAceptar.style.color = 'white';
                botonAceptar.style.border = 'none';
                botonAceptar.style.borderRadius = '5px';
                botonAceptar.style.padding = '10px 20px';
                botonAceptar.style.cursor = 'pointer';
                botonAceptar.style.display = 'block';
                botonAceptar.style.margin = '20px auto';

                botonAceptar.onclick = () => {
                    mostrarConsentimiento(elm);
                };

                elm.appendChild(botonAceptar);
            });

            waitForElm('.WACInputContainer').then(inputContainer => {
                if (inputContainer) {
                    inputContainer.remove();
                }
            });
        }

        function mostrarConsentimiento(elm) {
            elm.innerHTML = '';

            const titulo = document.createElement('h1');
            titulo.textContent = 'CONSENTIMIENTO DE DATOS';
            titulo.style.fontSize = '24px';
            titulo.style.fontWeight = 'bold';
            titulo.style.color = '#333';
            titulo.style.marginBottom = '10px';
            titulo.style.textAlign = 'center'; // Centrar el título
            elm.appendChild(titulo);

            // Texto
            const texto = document.createElement('p');
            texto.innerHTML =
                'En <strong>Cobas Asset Management</strong> trataremos tus datos personales con el fin de atender tu consulta y ponernos en contacto contigo. Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad escribiéndonos a <a href="mailto:protecciondedatos@cobasam.com">protecciondedatos@cobasam.com</a>. Más información en la ';

            const link = document.createElement('a');
            link.textContent = 'Política de Privacidad';
            link.href = 'https://www.cobasam.com/politica-de-privacidad/';
            link.target = '_blank'; // Abrir en nueva pestaña
            texto.appendChild(link);
            texto.style.fontSize = '16px';
            texto.style.color = '#666';
            texto.style.lineHeight = '1.5';
            texto.style.marginBottom = '30px';
            texto.style.textAlign = 'justify'; // Justificar el texto
            elm.appendChild(texto);

            // Contenedor de los botones centrado
            const buttonsContainer = document.createElement('div');
            buttonsContainer.style.display = 'flex';
            buttonsContainer.style.flexDirection = 'column'; // Botones uno encima del otro
            buttonsContainer.style.alignItems = 'center';
            buttonsContainer.style.gap = '10px';

            const commonButtonStyle = {
                width: '300px',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                padding: '10px 20px',
                cursor: 'pointer',
                fontSize: '16px'
            };

            const btnAceptar = document.createElement('button');
            btnAceptar.textContent = 'Acepto, quiero dejar mis datos';
            Object.assign(btnAceptar.style, commonButtonStyle, {
                backgroundColor: '#498b2a'
            });
            btnAceptar.onclick = () => recuperarContacto(elm);

            // Botón "No Acepto"
            const btnRechazar = document.createElement('button');
            btnRechazar.textContent = 'No acepto, seguir chateando de forma anónima';
            Object.assign(btnRechazar.style, commonButtonStyle, {
                backgroundColor: '#aaa'
            });
            btnRechazar.onclick = () => {
                elm.innerHTML = '';
                chatInstance.restartConversation();
            };

            buttonsContainer.appendChild(btnAceptar);
            buttonsContainer.appendChild(btnRechazar);

            elm.appendChild(buttonsContainer);
        }

        async function recuperarContacto(elm) {
            elm.innerHTML = '';
            const url = 'https://salesforce2.1rkxux47tjvb.eu-gb.codeengine.appdomain.cloud'; //preguntar por esto
            const jwtToken = jwt; // tu JWT en ámbito global

            try {
                // 1) Obtener contact_id
                const contactResp = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        tipo: 'get_contact_id',
                        token: jwtToken
                    })
                });
                if (contactResp.ok) {
                    const { contact_id } = await contactResp.json();
                    // console.log('Contact ID recuperado:', contact_id); // Log tras recuperación de contact_id

                    // 2) Crear caso
                    const caseResp = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            tipo: 'case',
                            contact_id,
                            texto: 'Contacto recuperado'
                        })
                    });
                    const caseResult = await caseResp.json();

                    if (caseResp.status === 201) {
                        conversacion_id = caseResult.conversacion_id;
                        // console.log('Caso creado con éxito con ID: ', caseResult.conversacion_id);
                    } else {
                        console.error('Error al crear el caso', caseResult);
                    }
                } else {
                    console.error('Error al recuperar contacto:', await contactResp.text());
                }
            } catch (e) {
                console.error('Error en el flujo de Salesforce:', e);
            } finally {
                chatInstance.restartConversation();
            }
        }

        function addImageToDiv(instance) {
            waitForElm('.WACBotContainer')
                .then(elm => {
                    if (!elm) {
                        console.error('Elemento no encontrado');
                        return;
                    }

                    const headers = elm.getElementsByClassName('WACHeader__CenterContainer');

                    if (headers[0].querySelector('.info-container')) {
                        return;
                    }

                    const container = document.createElement('div');
                    container.className = 'info-container';

                    const text = document.createElement('span');
                    text.innerHTML = '⟳';
                    text.style.cursor = 'pointer';
                    text.style.marginRight = '15px';
                    text.style.fontSize = '20px';

                    const info = document.createElement('span');
                    info.innerHTML = 'ⓘ';
                    info.style.cursor = 'pointer';
                    info.style.marginRight = '15px';
                    info.style.fontSize = '17px';
                    info.title =
                        'La información facilitada por el asistente virtual de Cobas Asset Management, S.G.I.I.C., S.A., Cobas IA, en ningún caso podrá entenderse como recomendación, previsión o asesoramiento financiero. En caso de discrepancia, la información recogida en la documentación legal y en la página web de Cobas Asset Management, S.G.I.I.C., S.A. prevalecerá frente a la información facilitada por el asistente virtual. Para cualquier aclaración contacte con el equipo de Relación con Inversores de Cobas Asset Management, S.G.I.I.C., S.A.';

                    text.onclick = () => doRefresh(instance);

                    container.appendChild(text);
                    headers[0].appendChild(container);

                    container.appendChild(info);
                    headers[0].appendChild(container);
                })
                .catch(err => {
                    console.error('Error al buscar el elemento:', err);
                });
        }

        function removeHtmlTags(str) {
            if (typeof str !== 'string') return '';
            // Eliminar etiquetas HTML
            let cleanedStr = str.replace(/<\/?[^>]+(>|$)/g, '');

            // Eliminar los asteriscos de negrita o cursiva
            cleanedStr = cleanedStr.replace(/\*\*([^*]+)\*\*/g, '$1'); // Elimina negrita (ej. **texto**)
            cleanedStr = cleanedStr.replace(/\*([^*]+)\*/g, '$1'); // Elimina cursiva (ej. *texto*)

            return cleanedStr;
        }

        function saveMessage(event) {
            const message = event.data;

            // Verifica si el mensaje es del usuario o del asistente y lo clasifica
            if (event.type === 'send') {
                // Si es un mensaje enviado por el usuario
                const texto = message.input ? message.input.text?.trim() : message.input?.trim(); //verifica si texto tiene contenido real (.trim() quita espacios y saltos vacíos)
                if (texto) {
                    messages.push({
                        sender: 'usuario',
                        text: texto
                    });
                }
            } else if (event.type === 'receive') {
                const cleanText = message.output?.generic
                    ?.map(item => removeHtmlTags(item.text))
                    .join(' ')
                    .trim();

                if (cleanText) {
                    messages.push({
                        sender: 'asistente',
                        text: cleanText
                    });

                    updateCaseHistory(); // Solo si el mensaje es válido
                }
            }
        }
        // Actualizar el caso en Salesforce con el historial
        async function updateCaseHistory() {
            if (!conversacion_id) {
                console.error('No hay conversacion_id disponible para actualizar el caso.');
                return;
            }

            // Genera el historial de conversación como texto
            const historial = generarTextoPlanoHistorial();
            // Prepara el payload para Salesforce
            const updatePayload = {
                tipo: 'update_case', // Usamos un endpoint para actualizar el caso
                conversacion_id: conversacion_id, // Id del caso que se está actualizando
                texto: historial // El historial de mensajes como descripción
            };

            // Enviar a Salesforce para actualizar el caso
            const url = 'https://salesforce2.1rkxux47tjvb.eu-gb.codeengine.appdomain.cloud'; // Reemplaza con tu endpoint adecuado
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(updatePayload)
                });

                const data = await response.json();

                if (response.status === 200) {
                    // console.log('Caso actualizado con éxito');
                } else {
                    console.error('Error al actualizar el caso:', data);
                }
            } catch (err) {
                console.error('Error de red al actualizar el caso:', err);
            }
        }

        function generarTextoPlanoHistorial() {
            return messages
                .map(message => {
                    const bloques = [];

                    if (message.sender === 'usuario' && message.text) {
                        bloques.push(`USUARIO: ${removeHtmlTags(message.text)}`);
                    }

                    if (message.sender === 'asistente' && message.text) {
                        // Mensaje del asistente
                        bloques.push(`ASISTENTE: ${removeHtmlTags(message.text)}`);
                    }

                    return bloques.join('\n');
                })
                .join('\n');
        }

        function createDocx() {
            try {
                const doc = new docx.Document({
                    sections: [
                        {
                            properties: {},
                            children: [
                                new docx.Paragraph({
                                    text: 'Historial de Chat',
                                    heading: docx.HeadingLevel.HEADING_1,
                                    style: {
                                        font: 'Roboto Slab'
                                    }
                                }),
                                ...messages
                                    .map(message => {
                                        const paragraphs = [];
                                        if (message.sender === 'usuario' && message.text) {
                                            // Mensaje del usuario
                                            paragraphs.push(
                                                new docx.Paragraph({
                                                    text: `TÚ: ${removeHtmlTags(message.text)}`,
                                                    style: {
                                                        font: 'Roboto Slab',
                                                        size: 14
                                                    }
                                                })
                                            );
                                        }
                                        if (message.sender === 'asistente' && message.text) {
                                            // Mensaje del asistente
                                            paragraphs.push(
                                                new docx.Paragraph({
                                                    text: `ASISTENTE: ${message.text}`,
                                                    style: {
                                                        font: 'Roboto Slab',
                                                        size: 14
                                                    }
                                                })
                                            );
                                            paragraphs.push(
                                                new docx.Paragraph({
                                                    text: ''
                                                })
                                            );
                                            paragraphs.push(
                                                new docx.Paragraph({
                                                    text: ''
                                                })
                                            );
                                        }
                                        return paragraphs;
                                    })
                                    .flat()
                            ]
                        }
                    ]
                });

                return doc;
            } catch (error) {
                console.error('Error creating the document:', error);
            }
        }

        function doDownload() {
            const doc = createDocx();

            docx.Packer.toBlob(doc).then(blob => {
                const timestamp = new Date().toISOString().replace(/[_:]/g, '-').replace(/\..+/, '');
                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = `Chat_History_${timestamp}.docx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });
        }

        function doRefresh(instance) {
            instance.restartConversation().then(() => {
                addImageToDiv(instance);
            });
        }

        function sendInactivityMessage(instance) {
            if (primero == 0) {
                const sendObject = {
                    input: {
                        message_type: 'text',
                        text: 'msdfin'
                    }
                };

                instance.send(sendObject, {
                    silent: true
                });
                mensajeEnviado = true;
                clearTimeout(inactivityTimer);
            }
            primero++;
        }

        function startInactivityTimer(instance) {
            clearTimeout(inactivityTimer);
            inactivityTimer = setTimeout(() => {
                if (!mensajeEnviado) {
                    sendInactivityMessage(instance);
                }
            }, inactivityInterval);
        }

        let loadingMessageDiv;

        function showLoadingMessage(messagesContainer) {
            if (!loadingMessageDiv) {
                loadingMessageDiv = document.createElement('div');
                loadingMessageDiv.className = 'WAC__LoadingMessage';
                loadingMessageDiv.style.padding = '10px 20px';
                loadingMessageDiv.style.borderRadius = '8px';
                loadingMessageDiv.style.marginBottom = '10px';
                loadingMessageDiv.style.fontSize = '16px';
                loadingMessageDiv.style.color = '#333';
                loadingMessageDiv.style.fontStyle = 'italic';
                loadingMessageDiv.style.whiteSpace = 'nowrap';

                const text = 'Buscando información...';
                loadingMessageDiv.innerHTML = '';
                Array.from(text).forEach(letter => {
                    if (letter === ' ') {
                        const spaceSpan = document.createElement('span');
                        spaceSpan.textContent = ' ';
                        loadingMessageDiv.appendChild(spaceSpan);
                    } else {
                        const letterSpan = document.createElement('span');
                        letterSpan.textContent = letter;
                        letterSpan.style.display = 'inline-block';
                        letterSpan.style.opacity = '0.5';
                        loadingMessageDiv.appendChild(letterSpan);
                    }
                });

                messagesContainer.appendChild(loadingMessageDiv);
                messagesContainer.scrollTop = messagesContainer.scrollHeight;
            }
        }

        const style = document.createElement('style');
        style.innerHTML = `
            @keyframes wave {
                0%, 100% {
                    transform: translateY(0);  
                    opacity: 0.5; 
                }
                50% {
                    transform: translateY(-10px); 
                    opacity: 1;  
                }
            }
            `;
        document.head.appendChild(style);

        function hideLoadingMessage() {
            if (loadingMessageDiv) {
                loadingMessageDiv.remove();
                loadingMessageDiv = null;
                const textArea = document.getElementById('WACInputContainer-TextArea');
                textArea.disabled = false;
            }
        }

        function preventLoadingIcon() {
            const observer = new MutationObserver(mutationsList => {
                mutationsList.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) {
                            const loadingIcon = node.querySelector('cds-aichat-inline-loading');
                            if (loadingIcon) {
                                loadingIcon.remove();
                            }
                        }
                    });
                });
            });

            const config = {
                childList: true,
                subtree: true
            };
            observer.observe(document.body, config);
        }

        function observeBotMessages() {
            waitForElm('.WAC__messages')
                .then(messagesContainer => {
                    const observer = new MutationObserver(mutationsList => {
                        mutationsList.forEach(mutation => {
                            mutation.addedNodes.forEach(node => {
                                if (node.nodeType === 1) {
                                    const botMessage = node.querySelector('.WAC__bot-message');
                                    if (botMessage) {
                                        const messageText = botMessage.textContent.trim();
                                        if (messageText.length > 0) {
                                            hideLoadingMessage();
                                        }
                                    }
                                }
                            });
                        });
                    });

                    const config = {
                        childList: true,
                        subtree: true
                    };
                    observer.observe(messagesContainer, config);
                })
                .catch(err => {
                    console.error('Error al buscar el contenedor de mensajes:', err);
                });
        }

        function onUserMessageSent(instance) {
            const textArea = document.getElementById('WACInputContainer-TextArea');
            if (textArea) {
                textArea.disabled = true;
            }

            waitForElm('.WAC__messages')
                .then(messagesContainer => {
                    showLoadingMessage(messagesContainer);
                })
                .catch(err => {
                    console.error('Error al buscar el contenedor de mensajes:', err);
                });

            startInactivityTimer(instance);
        }

        function handlerAssitantMessages(event) {
            // Recorremos los mensajes generados por el asistente
            const generic = event.data.output.generic;

            for (let i = 0; i < generic.length; i++) {
                const item = generic[i];
                // console.log(item.response_type);
                // Si el mensaje contiene texto
                if (item.response_type == 'text' && item.text) {
                    // Formateamos los enlaces en el texto
                    item.text = formatLinksInMessage(item.text);
                }
            }
        }

        function minimizeWidget(instance) {
            instance.changeView({
                mainWindow: false,
                launcher: true
            });
        }

        function is_small() {
            if (window.matchMedia('(max-width: 768px)').matches) {
                return true;
            }

            return false;
        }

        // Función para formatear los enlaces en los mensajes
        function formatLinksInMessage(messageText) {
            // console.log('Formateando enlaces en el mensaje:', messageText);
            const CUSTOM_SCHEME = 'cobasapp://';
            const isPhone = is_small();
            const isNative = Capacitor.isNativePlatform();

            // Primero, intentamos formatear enlaces HTML
            const htmlRegex = /<a\s+[^>]*href="([^"]+)"[^>]*>([^<]+)<\/a>/g;
            let formattedText = messageText.replace(htmlRegex, (match, url, linkText) => {
                // Verificamos si la URL contiene "private"
                let processedURL = url;
                if (url.includes('private')) {
                    if (isNative) {
                        processedURL = url.split('/private')[1] || '';
                    }
                }

                const hash = new URL(processedURL.trim()).hash;
                const urlCustomScheme = isNative ? `${CUSTOM_SCHEME}${hash}` : processedURL;
                const classAttr = isPhone ? 'class="url_asistente"' : '';
                return `<a ${classAttr} href="${urlCustomScheme}" target="_self" rel="noopener noreferrer">${linkText}</a>`;
            });

            // Luego, formateamos enlaces Markdown
            const markdownRegex =
                /\[([^\]]+)\]\(((https?:\/\/|capacitor:\/\/)[^\s()]+(?:\([^\s()]*\)[^\s()]*)*)\)/g;

            formattedText = formattedText.replace(markdownRegex, (match, linkText, url) => {
                let processedURL = url;
                if (url.includes('private')) {
                    if (isNative) {
                        processedURL = url.split('/private')[1] || '';
                    }
                }
                const hash = new URL(processedURL.trim()).hash;
                const urlCustomScheme = isNative ? `${CUSTOM_SCHEME}${hash}` : processedURL;
                const classAttr = isPhone ? 'class="url_asistente"' : '';
                return `<a ${classAttr} href="${urlCustomScheme}" target="_self" rel="noopener noreferrer">${linkText}</a>`;
            });

            // Enlaces sin href ni markdown
            const rg =/(?<!href=")(?<!\]\()https?:\/\/(?:(?!\/#\/)[^\s<>"\]])+/g;

            formattedText = formattedText.replace(rg, (match) => {
                // Verificamos si la URL contiene "private"
                let classAttr = '';
                if (isNative) {
                    classAttr += 'cobas-ap-external-native '
                                }
                if (isPhone) {
                    classAttr += 'url_asistente ';
                }

                return `<a class="${classAttr}" href="${match}" target="_self" rel="noopener noreferrer">${match}</a>`;
            });

            return formattedText;
        }

        async function encryptText(
            plain,
            baseUrl = 'https://encryption-api.1rkxux47tjvb.eu-gb.codeengine.appdomain.cloud'
        ) {
            const resp = await fetch(`${baseUrl}/encrypt`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    text: plain
                })
            });

            if (!resp.ok) throw new Error(`Error ${resp.status}: ${await resp.text()}`);

            const data = await resp.json();
            if (!data.success) throw new Error('La encriptación falló');
            return data.encrypted_text; // ← cadena cifrada lista para usar
        }

        async function TokenHandler(event) {
            const skills = event.data.context.skills;
            skills['actions skill'] = skills['actions skill'] || {};
            skills['actions skill'].skill_variables = skills['actions skill'].skill_variables || {};

            // Llamada ÚNICA
            const encrypted = await encryptText(jwt);
            // console.log('Token cifrado:', encrypted);

            skills['actions skill'].skill_variables.token = encrypted;
        }

        window.watsonAssistantChatOptions = {
            integrationID: process.env.VUE_APP_WATSON_INTEGRATIONID,
            region: 'eu-gb', // The region your integration is hosted in.
            serviceInstanceID: process.env.VUE_APP_WATSON_SERVICEINSTANCEID, // The ID of your service instance.
            onLoad: async instance => {
                chatInstance = instance;

                document.body.addEventListener('click', function (event) {
                    const link = event.target.closest('a.url_asistente');
                    const isExternalNative = event.target.closest('a.cobas-ap-external-native');
                    if (link) {
                        if (isExternalNative) {
                            event.preventDefault();
                            let inAppBrowserOptions = 'location=no, beforeload=yes';
                            if (Capacitor.getPlatform() === 'android') {
                                inAppBrowserOptions += ',zoom=no';
                            }

                            const inAppBrowswerType = Capacitor.getPlatform() === 'ios' ? '_self' : '_system';
                            window.cordova.InAppBrowser.open(
                                encodeURI(isExternalNative.href),
                                inAppBrowswerType,
                                inAppBrowserOptions
                            );
                        }
                        minimizeWidget(chatInstance);
                    }
                });

                instance.once({
                    type: 'pre:send',
                    handler: TokenHandler
                });

                await instance.updateLocale('es');
                instance.render();
                instance.on({
                    type: 'pre:receive',
                    handler: handlerAssitantMessages
                });
                instance.on({
                    type: 'receive',
                    handler: saveMessage
                });
                instance.on({
                    type: 'send',
                    handler: saveMessage
                });
                instance.on({
                    type: 'receive',
                    handler: () => {
                        hideLoadingMessage();
                    }
                });
                instance.on({
                    type: 'send',
                    handler: () => {
                        onUserMessageSent(instance);
                    }
                });

                instance.once({
                    type: 'chat:ready',
                    handler: () => {
                        limpiarYAgregarContenido();
                    }
                });

                observeBotMessages();
                preventLoadingIcon();

                instance.on({
                    type: 'chat:ready',
                    handler: () => {
                        addImageToDiv(instance);
                        startInactivityTimer(instance);
                        const messageInput = instance.elements.getMessageInput();
                        const messageInputElement = messageInput.getHTMLElement();

                        const resetAndStartTimer = () => {
                            mensajeEnviado = false;
                            startInactivityTimer(instance);
                            primero = 0;
                        };

                        messageInputElement.addEventListener('input', resetAndStartTimer);
                        messageInputElement.addEventListener('keydown', resetAndStartTimer);
                        const assistantContainer = document.querySelector('.WACBotContainer');
                        assistantContainer.addEventListener('click', resetAndStartTimer);

                        instance.on({
                            type: 'send',
                            handler: () => {
                                mensajeEnviado = false;
                            }
                        });
                    }
                });

                instance.updateCustomMenuOptions('bot', [
                    {
                        text: 'Descargar Historial',
                        handler: doDownload
                    }
                ]);
            },
            hideCloseAndRestartButton: true
        };
    };

    window.loadWatsonScript = function() {
        setTimeout(function() {
            const t = document.createElement('script');
            t.src = 'https://web-chat.global.assistant.watson.appdomain.cloud/versions/' + (window.watsonAssistantChatOptions.clientVersion || 'latest') + '/WatsonAssistantChatEntry.js';
            document.head.appendChild(t);
        }, 0);
    };
    import AppVersionModal from '@/components/AppVersionModal/index.vue';
    import FooterAgent from '@/components/FooterAgent/index.vue';

    export default {
        components: {
            AppVersionModal,
            FooterAgent,
        },
        data() {
            return {
                isMobile: window.innerWidth <= 991,
                watsonInitialized: false,
                hasAiAssistantEnabled: true
            }
        },
        computed: {
            /**
             * Comprueba si está logeado o no
             * @return {Boolean} Estado del login
             */
            isLogged() {
                return this.$route.meta.guest ? false : true;
            }
        },
        watch: {
            $route: {
                immediate: true,
                handler() {
                    const token = localStorage.getItem('PACOAT');
                    if (token) {
                        document.body.classList.remove('no-logged');
                        // Initialize Watson with configuration check
                        if (!this.watsonInitialized) {
                            this.initializeWatsonIfEnabled();
                        }
                    } else {
                        document.body.classList.add('no-logged');
                    }
                }
            }
        },
        methods: {
            async initializeWatsonIfEnabled() {
                // Check if AI Assistant is enabled before initializing
                try {
                    const { default: userService } = await import('@/services/users.service');
                    const configHasAiAssistantEnabled = await userService.getConfig(
                        {},
                        'HAS_AI_ASSISTENT_ENABLED'
                    );
                    let hasAiAssistantEnabled = configHasAiAssistantEnabled?.data?.configuration?.value;
                    if (typeof hasAiAssistantEnabled === 'string') {
                        hasAiAssistantEnabled = JSON.parse(hasAiAssistantEnabled);
                    }
                    this.hasAiAssistantEnabled = hasAiAssistantEnabled !== false;
                    
                    if (this.hasAiAssistantEnabled) {
                        window.initWatson();
                        window.loadWatsonScript();
                        this.watsonInitialized = true;
                    }
                } catch (e) {
                    // if config fails, default to enabled
                    this.hasAiAssistantEnabled = true;
                    window.initWatson();
                    window.loadWatsonScript();
                    this.watsonInitialized = true;
                }
            }
        }
    };

</script>
